var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-otp-input',{staticClass:"meter",attrs:{"type":'number',"length":8},on:{"change":_vm.onChange},model:{value:(_vm.collect),callback:function ($$v) {_vm.collect=$$v},expression:"collect"}}),(_vm.errorMessages)?_c('ErrorLabel',{attrs:{"message":_vm.errorMessages}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }